"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDefaultProps = exports.createOverrides = void 0;
var fonts_1 = require("../fonts");
var appbar_1 = require("./appbar");
var button_1 = require("./button");
var tab_1 = require("./tab");
var tabs_1 = require("./tabs");
var formHelperText_1 = require("./formHelperText");
var outlinedInput_1 = require("./outlinedInput");
var textField_1 = require("./textField");
var select_1 = require("./select");
var menuItem_1 = require("./menuItem");
var tooltip_1 = require("./tooltip");
var checkbox_1 = require("./checkbox");
var drawer_1 = require("./drawer");
var inputLabel_1 = require("./inputLabel");
var chip_1 = require("./chip");
exports.createOverrides = function (props) { return ({
    MuiCssBaseline: {
        "@global": {
            "@font-face": fonts_1.gilroy,
        },
    },
    MuiAppBar: appbar_1.createAppBarTheme(props),
    MuiButton: button_1.createButtonTheme(props),
    MuiTab: tab_1.createTabTheme(props),
    MuiTabs: tabs_1.createTabsTheme(props),
    MuiFormHelperText: formHelperText_1.createFormHelperTheme(props),
    MuiOutlinedInput: outlinedInput_1.createOutlinedInputTheme(props),
    MuiTextField: textField_1.createTextFieldTheme(props),
    MuiSelect: select_1.createSelectTheme(props),
    MuiMenuItem: menuItem_1.createMenuItemTheme(props),
    MuiCheckbox: checkbox_1.createCheckboxTheme(props),
    MuiTooltip: tooltip_1.createTooltipTheme(props),
    MuiDrawer: drawer_1.createDrawerTheme(props),
    MuiInputLabel: inputLabel_1.createInputLabelTheme(props),
    MuiChip: chip_1.createChipTheme(props),
}); };
exports.createDefaultProps = function (props) { return ({
    MuiAppBar: appbar_1.createAppBarDefaultProps(props),
    MuiButton: button_1.createButtonDefaultProps(props),
    MuiTab: tab_1.createTabDefaultProps(props),
    MuiTabs: tabs_1.createTabsDefaultProps(props),
}); };
